import {
  ContentType,
  SearchUsersContentVisibilityDocument,
  useRemoveUsersContentVisibilityMutation,
} from '@exam-management/graphql';
import { useNavigateModals } from '@exam-management/router';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Text,
} from '@shared/components';
import { useSnackbar } from '@shared/snackbar';
import { useLocation } from 'react-router-dom';

export default function ConfirmRemoveUserFromQBankStructure() {
  const { close, current } = useNavigateModals('/confirm-remove-user-from-qbank-structure');

  const [remove, { loading: isLoading }] = useRemoveUsersContentVisibilityMutation({
    onCompleted: (res) => {
      if (res.cvRemoveUsersContentVisibility) {
        showSnackbar({ message: 'Remove Successfully', variant: 'success' });
        close();
      }
    },
    onError: (error) => {
      showSnackbar({ message: error.message, variant: 'error' });
    },
    refetchQueries: [SearchUsersContentVisibilityDocument],
  });

  const { state } = useLocation();
  const { showSnackbar } = useSnackbar();
  const { structureId = '', userId = '' } = state;

  const onClose = () => {
    close();
  };

  const removeUserFromRole = () => {
    remove({
      variables: {
        input: {
          contentId: structureId,
          contentType: ContentType.QbankStructure,
          userIds: [userId],
        },
      },
    });
  };

  return (
    <Dialog
      open={current === '/confirm-remove-user-from-qbank-structure'}
      onClose={isLoading ? undefined : onClose}
      maxWidth='xs'
    >
      <DialogTitle onClose={onClose}>Remove user?</DialogTitle>
      <DialogContent>
        <Text>
          การ Remove User&nbsp;
          <Text component='span' variant='body1Semibold'>
            จะยกเลิกเข้าถึงฟีเจอร์ที่เกี่ยวข้องกับบทบาทนี้
          </Text>
          <br />
          กรุณาตรวจสอบให้แน่ใจก่อนดำเนินการ
        </Text>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='secondary' variant='outlined' disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={removeUserFromRole} color='error' loading={isLoading}>
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}
